import { BrowserModule } from '@angular/platform-browser';
import { Component, ViewChild, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, NgModel } from '@angular/forms';
import { AppComponent } from '../../app.component';
import { LoginService } from '../service/login.service';
import { AuthorizationService } from '../service/authorization.service';
// import { OAuthProvider } from '@firebase/auth-types';
import { Router } from '@angular/router';
// import { AngularFire, AuthProviders, AuthMethods } from 'angularfire2';


@Component({
    selector: 'login',
    templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {

    //Variables para creación de formularios
    public registerForm: FormGroup;


    constructor(
        private appComponent: AppComponent,
        private loginService: LoginService,
        private authorizationService: AuthorizationService,
        // public af: AngularFire,
        private router: Router
    ) { }

    /**
     * variable para desabilitar el boton de guardar mientra se esta enviando el formulario 
     * */
    buttonStatus = false;

    /**
     * variable para desabilitar el boton de guardar mientra se esta enviando el formulario 
     * */
    validatePassw = false;

    /**
     * variable para guardar el repassword
     * */
    repassword: string;

    dataSession:any;
    dataUser:any;

    user = {
        username: '',
        password: '',
        device_platform: "web"
    }

    ngOnInit() {
        this.createForm();
    }

    
    /**
   * Metodo encargado de crear el formulario que manejara los datos basicos del cliente
   */
    createForm() {
        this.registerForm = new FormGroup({
            username: new FormControl('', [<any>Validators.required]),
            password: new FormControl('', [<any>Validators.required]),
        });
    }

    loginGoogle(){
        this.authorizationService
        .login()
        .then((data)=>{
            console.log('data ==>', data);
        })
        .catch((error)=>{
            console.log('error ==>', error);
        })
    }

    // loginFb(){
    //     this.authorizationService
    //     .login({
    //         provider : OAuthProvider.Facebook,
    //         method: AuthMethods.Popup,
    //     }
           
    //     )
    //     .then((data)=>{
    //         console.log('data ==>', data);
    //     })
    //     .catch((error)=>{
    //         console.log('error ==>', error);
    //     })
    // }

    login(){
        
        this.loginService
        .login(this.user)
        .subscribe(response => {
            let responseData:any= response;
          if(responseData.errors){
             this.errorLogin();
          }else{
              console.warn('logeado');
          }
          this.dataSession = response['data']['mobile_sessions'][0];
          delete response['data']['mobile_sessions'];
          this.dataUser = response['data'];
          localStorage.setItem('auth_token', this.dataSession.apiKey);
          localStorage.setItem('dataSession', JSON.stringify(this.dataSession));
          localStorage.setItem('dataUser', JSON.stringify(this.dataUser));
        },error => {
            console.warn(error);
        this.errorLogin();
        });
      }


    errorLogin() {
        console.warn('no logeado');
    }
}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/login/login.component.ts